module.exports = __webpack_public_path__ + "img/shadow.d611fab1.png";